import React from 'react';
import { Box } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';

import { customSizes, spaces } from '../../assets/styles/themes/tokens';
import EmptySearchStateImage from '../Search/SearchResults/EmptySearchResultsNewUI/EmptySearchStateImage';
import { Link } from 'found';
import { routes } from '../../constants';

const FollowedCollectionsEmptyState = () => {
  const { t } = useTranslation();

  return (
    <Box data-testid='followed-collections-empty-state' sx={{ padding: spaces.xl }}>
      <EmptySearchStateImage
        title={t('You are not following any collections currently')}
        subtitle={
          <Trans
            i18nKey='Discover our curated collections, follow your favorites, and easily find them here'
            key={1}
          >
            <Link to={`/${routes.curatedCollections.root}`}></Link>
          </Trans>
        }
        subtitleSx={{ maxWidth: customSizes.emptyStateSubtitleMaxWidth, textAlign: 'center' }}
        containerSx={{ paddingBottom: 0 }}
        iconName='notFound'
      />
    </Box>
  );
};

export default FollowedCollectionsEmptyState;
